<dx-popup [showTitle]="true" title="Nuovo allegato" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
  [showCloseButton]="true" container=".dx-viewport" visible="true" (onHiding)="onEsciClick()" height="80vh">
  <h4>Movimento del dipendente {{dipendente?.nominativo}} - {{mov?.data  | date: 'dd/MM/yyyy'}}</h4>
  <div class="row">
    <div class="col-6 col-md-4">
      <div class="dx-fieldset-header">Nome allegato</div>
      <dx-text-box [(value)]="nomeAllegato">
        <dx-validator>
          <dxi-validation-rule type="required" message="Inserire il nome"></dxi-validation-rule>
        </dx-validator>

      </dx-text-box>

    </div>
  </div>
  <div class="row">
    <div class="col-6 col-md-4">
      <div class="widget-container">

        <div class="dx-fieldset-header">File</div>
        <dx-file-uploader
          #fileUploader

          [multiple]="false"
          accept="*"
          [(value)]="value"
          uploadMode="useForm"
          >
          <dx-validator>
            <dxi-validation-rule type="required" message="Selezionare il file"></dxi-validation-rule>
          </dx-validator>
        </dx-file-uploader>
        <div class="content">
          @if (value.length > 0) {
            <div>
              <h4>Selected Files</h4>
            </div>
          }
          @for (file of value; track file) {
            <div>
              <div class="selected-item">
                Name:
                <span>{{file.name}}</span><br /> Size:
                <span>{{file.size}}</span>bytes<br /> Type:
                <span>{{file.type}}</span><br /> Last Modified Date:
                <span>{{file.lastModifiedDate}}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6 col-md-4">
      <div class="dx-fieldset">

      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-6 col-md-4">
      <dx-button
        stylingMode="contained"
        text="Allega"
        type="normal"
        width="120"
        type="success"
        (onClick)="allegaFile($event, fileUploader.value)">
      </dx-button>
    </div>
  </div>
</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible"
  [showIndicator]="true" [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>



